import { useEffect, useState } from 'react';
import Router, { NextRouter } from 'next/router';
import NProgress from 'nprogress';
import { TenantEnv } from '../types';

export const useRouterEffect = (
  router: NextRouter,
  globalData: TenantEnv,
  restorePositionWhenBack = false,
) => {
  const [scrollPos, setScrollPos] = useState<{
    [key: string]: { x: number; y: number };
  }>({});
  const addScrollPos = (url: string) => {
    const newScrollPos = { x: window.scrollX, y: window.scrollY };
    setScrollPos((prev) => {
      return {
        ...prev,
        [url]: newScrollPos,
      };
    });
  };
  const restoreScrollPos = (url: string) => {
    if (scrollPos[url]) {
      window.scrollTo(scrollPos[url].x, scrollPos[url].y);
    }
  };
  useEffect(() => {
    Router.events.on('routeChangeStart', () => {
      NProgress.start();
    });
    Router.events.on('routeChangeComplete', () => NProgress.done());
    Router.events.on('routeChangeError', () => NProgress.done());
  }, []);

  useEffect(() => {
    if ('scrollRestoration' in window.history && restorePositionWhenBack) {
      let shouldScrollRestore = false;
      window.history.scrollRestoration = 'manual';
      restoreScrollPos(router.asPath);

      const onRouteChangeStart = () => {
        addScrollPos(router.asPath);
      };
      const onRouteChangeComplete = (url: string) => {
        if (shouldScrollRestore) {
          shouldScrollRestore = false;
          restoreScrollPos(url);
        }
      };

      Router.events.on('routeChangeStart', onRouteChangeStart);
      Router.events.on('routeChangeComplete', onRouteChangeComplete);
      Router.beforePopState(() => {
        shouldScrollRestore = true;
        return true;
      });

      return () => {
        Router.events.off('routeChangeStart', onRouteChangeStart);
        Router.events.off('routeChangeComplete', onRouteChangeComplete);
        Router.beforePopState(() => true);
      };
    }
  }, [router]);
};
